// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer__article[data-v-2a293e9f]{margin-bottom:.5rem}.footer__article[data-v-2a293e9f]:last-child{margin-bottom:0}.footer__category[data-v-2a293e9f]{margin-bottom:.5rem}@media (min-width:430px){.media-group[data-v-2a293e9f]{gap:16px}}@media (min-width:640px){.footer__article[data-v-2a293e9f]{margin-bottom:1rem}.footer__category[data-v-2a293e9f]{margin-bottom:.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
